
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class WhatsAppGatewaySettingsDialog extends Serenity.EntityDialog<WhatsAppGatewaySettingsRow, any> {
        protected getFormKey() { return WhatsAppGatewaySettingsForm.formKey; }
        protected getIdProperty() { return WhatsAppGatewaySettingsRow.idProperty; }
        protected getLocalTextPrefix() { return WhatsAppGatewaySettingsRow.localTextPrefix; }
        protected getNameProperty() { return WhatsAppGatewaySettingsRow.nameProperty; }
        protected getService() { return WhatsAppGatewaySettingsService.baseUrl; }
        protected getDeletePermission() { return WhatsAppGatewaySettingsRow.deletePermission; }
        protected getInsertPermission() { return WhatsAppGatewaySettingsRow.insertPermission; }
        protected getUpdatePermission() { return WhatsAppGatewaySettingsRow.updatePermission; }

        protected form = new WhatsAppGatewaySettingsForm(this.idPrefix);

    }
}